import actions from '../../actions';

import { handleActions } from 'redux-actions';

const initialState = {
  adjudications: [undefined, undefined, undefined],
};

const { reset, show } = actions.competition.refereeLights;

const reducer = handleActions(
  {
    [reset]: () => initialState,
    [show]: (state, { payload: { adjudications } }) => {
      console.log('ADJUDICATIONS', adjudications);
      return {
        adjudications,
      };
    },
  },
  initialState,
);

export default reducer;



// WEBPACK FOOTER //
// ./src/venue/reducers/competition/refereeLights.js